import React, { Component } from 'react';
import "./DnsSearchRoute.css";
import { DomainSearchFilter } from './../Filters';
import DnsSearchResult from './DnsSearchResult';

class DnsSearchRoute extends Component {    
    handleSearch = (filter) => {        
        this.props.searchDomainsRecord(filter);
    }

    render() {
        const {dnsSearchResult} = this.props;
        return (<div className="main-content container DnsSearchRoute">
            <div className="filter DnsSearchFilter">
                <DomainSearchFilter
                    onSearch={this.handleSearch}
                />
                <DnsSearchResult dnsSearchData={dnsSearchResult} />
            </div>
        </div>);
    }
}

export default DnsSearchRoute; 


// WEBPACK FOOTER //
// ./src/components/DnsSearchRouteComponent/DnsSearchRoute.js